import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
export const FormsModuleNgFactory:i0.NgModuleFactory<i1.FormsModule> = (null as any);
var _decl0_0:i1.NgModel = (<any>(null as any));
var _decl0_1:i1.NgModelGroup = (<any>(null as any));
var _decl0_2:i1.NgForm = (<any>(null as any));
var _decl0_3:i1.ɵba = (<any>(null as any));
var _decl0_4:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_5:i0.ElementRef = (<any>(null as any));
export const ReactiveFormsModuleNgFactory:i0.NgModuleFactory<i1.ReactiveFormsModule> = (null as any);
var _decl1_0:i1.FormControlDirective = (<any>(null as any));
var _decl1_1:i1.FormGroupDirective = (<any>(null as any));
var _decl1_2:i1.FormControlName = (<any>(null as any));
var _decl1_3:i1.FormGroupName = (<any>(null as any));
var _decl1_4:i1.FormArrayName = (<any>(null as any));
var _decl1_5:i1.ɵba = (<any>(null as any));
var _decl1_6:i0.TemplateRef<any> = (<any>(null as any));
var _decl1_7:i0.ElementRef = (<any>(null as any));
export const ɵbaNgFactory:i0.NgModuleFactory<i1.ɵba> = (null as any);
var _decl2_0:i1.ɵbf = (<any>(null as any));
var _decl2_1:i1.NgSelectOption = (<any>(null as any));
var _decl2_2:i1.ɵq = (<any>(null as any));
var _decl2_3:i1.DefaultValueAccessor = (<any>(null as any));
var _decl2_4:i1.ɵbc = (<any>(null as any));
var _decl2_5:i1.ɵbe = (<any>(null as any));
var _decl2_6:i1.CheckboxControlValueAccessor = (<any>(null as any));
var _decl2_7:i1.SelectControlValueAccessor = (<any>(null as any));
var _decl2_8:i1.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl2_9:i1.RadioControlValueAccessor = (<any>(null as any));
var _decl2_10:i1.NgControlStatus = (<any>(null as any));
var _decl2_11:i1.NgControlStatusGroup = (<any>(null as any));
var _decl2_12:i1.RequiredValidator = (<any>(null as any));
var _decl2_13:i1.MinLengthValidator = (<any>(null as any));
var _decl2_14:i1.MaxLengthValidator = (<any>(null as any));
var _decl2_15:i1.PatternValidator = (<any>(null as any));
var _decl2_16:i1.CheckboxRequiredValidator = (<any>(null as any));
var _decl2_17:i1.EmailValidator = (<any>(null as any));
var _decl2_18:i0.TemplateRef<any> = (<any>(null as any));
var _decl2_19:i0.ElementRef = (<any>(null as any));
